import { useLocale } from "@/i18n/LocaleProvider";
import { efforts, priorities, types } from "@/defaultData";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import lowSvg from "../assets/low.svg";
import defaultPriority from "../assets/defaultPriority.svg";
import defaultType from "../assets/defaultType.svg";
import { MultiSelect } from "./ui/multi-select";

export const CustomSelect = ({
  value,
  options,
  defaultName,
  defaultIconScr,
  setClusterFilters,
  onValueChange,
}: {
  setClusterFilters?: any;
  value: any;
  options: any[];
  defaultIconScr: string;
  defaultName: string;
  onValueChange?: (value: string) => void;
}) => {
  return (
    <Select
      value={value}
      onValueChange={(v) => {
        if (onValueChange) {
          onValueChange(v);
          return;
        }
        if (setClusterFilters) {
          if (v === defaultName) {
            setClusterFilters(null);
          } else {
            setClusterFilters(v);
          }
        }
      }}
    >
      <SelectTrigger
        size="default"
        className="w-fit px-1 py-1 text-[#0A0A0A]"
        onClick={(e) => e.stopPropagation()}
      >
        <SelectValue className="flex items-center gap-1 text-[#0A0A0A]">
          {options.find((opt) => opt.value === value)?.icon || (
            <img src={defaultIconScr}></img>
          )}
          {options.find((opt) => opt.value === value)?.label || defaultName}
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        <SelectItem
          onPointerDown={(e) => e.stopPropagation()}
          key={defaultName}
          value={defaultName}
        >
          <div className="flex items-center gap-2">{defaultName}</div>
        </SelectItem>
        {options.map((option) => (
          <SelectItem
            onPointerDown={(e) => e.stopPropagation()}
            key={option.value}
            value={option.value}
          >
            <div className="flex items-center gap-2">
              {option.icon}
              {option.label}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

export const ClusterFilters = ({ clusterFilters, setClusterFilters }: any) => {
  const { t } = useLocale();
  return (
    <>
      <MultiSelect
        options={types}
        disabled={false}
        showIcon={true}
        onChange={(value: string[]) => {
          setClusterFilters({ ...clusterFilters, type: value });
        }}
        selected={clusterFilters.type || []}
        placeholder={t("legacy.all.types.59qzzj")}
      >
        <img src={defaultType}></img>
      </MultiSelect>
      <MultiSelect
        options={priorities}
        disabled={false}
        showSearch={false}
        showIcon={true}
        onChange={(value: string[]) => {
          setClusterFilters({ ...clusterFilters, priority: value });
        }}
        selected={clusterFilters.priority || []}
        placeholder={t("legacy.all.priorities.qw20z4")}
      >
        <img src={defaultPriority}></img>
      </MultiSelect>
      <MultiSelect
        options={efforts}
        disabled={false}
        showSearch={false}
        showIcon={true}
        onChange={(value: string[]) => {
          setClusterFilters({ ...clusterFilters, effort: value });
        }}
        selected={clusterFilters.effort || []}
        placeholder={t("legacy.all.efforts.1mgxgsb")}
      >
        <img src={lowSvg}></img>
      </MultiSelect>
    </>
  );
};
